import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  c1,
  MENU_BUTTON_CODE,
  MENU_BUTTON_STYLE,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { ButtonOption, MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-button-web-media-component",
  templateUrl: "./button-web-media-component.component.html",
  styleUrls: ["./button-web-media-component.component.scss"],
})
export class ButtonWebMediaComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    public builderService: BuilderService
  ) {}

  @Input() button: MenuButton;
  @Input() fontSmaller = false;
  @Input() mode: string;
  @Input() fontResize;

  @Input() row_id: string;

  @Input() data: Tab;
  @Input() colors: any;
  @Input() no_buttons = 1;
  @Input() ref: any;
  //////////////////// what have been used //////////////
  currentMenuSubscription: any;
  updateBuilderComponentSubscription: any;
  colorsComponentSubscription: any;
  offCanvasSubscription: any;
  bgImageP1: string = null;
  card_round: string;
  sec_round: string;
  transparent: boolean = false;
  bg_image: string = null;
  bg_color: string = null; // = "#000000";;
  start_color: string = null; // = "#1be6e2";
  end_color: string = null; //= "#1be6e2";
  image: string = null;
  album_button: any;
  albums: any;
  emptyImage: string;
  emptyImageP0: string;
  emptyImageP1: string;
  emptyImageP2: string;
  widthP0: string;
  styleP0: number = 1;
  styleP1: number = 0;
  styleP2: number = 0;
  label: string;
  sublable: string;
  label_color: string;
  sublabel_color: string;
  settings: any;

  border_color: string;
  imageOvel: string;
  /////
  isAndroid: boolean;
  current_button: any;
  isActive: boolean;
  light: boolean = true;
  color_schema: any;
  color_schema_ios: any;
  label_align: string;
  sublabel_align: string;
  label_size: string;
  sublabel_size: string;

  textAlign: any = {};
  textFontsize: any = {};
  outlined: boolean;
  elevated: boolean;
  filled: boolean;
  shadow: boolean;
  surfaceColor: string;
  imageUploaderSubOption: any;
  currentImages: any = [];
  ngOnInit() {
    let style = this.isAndroid
      ? this.button.button_style
      : this.button.button_style_ios;

    this.imageUploaderSubOption = {
      title: "Upload Image",
      max: 1,
      cropperView: false,
      resizeToWidth: 370,
      resizeToHeight: 370,
      removeButton: true,
      removePadding: true,
      lightTheme: true,
      fullImage: true,
      acceptedFiles: "image/jpeg,image/pjpeg,image/png",
      media_type: "image",
      mode: ["upload", "gallery", "url"],
    };

    this.initialize(this.button.button_style, this.no_buttons);

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (data && !data.fromButton) {
          if (data["sortedButtonList"][this.row_id]) {
            this.no_buttons =
              data["sortedButtonList"][this.row_id].length > 0
                ? data["sortedButtonList"][this.row_id].length
                : 1;
            this.current_button = data["currentButton"];
            this.isActive =
              this.current_button &&
              this.current_button.button_id == this.button.button_id
                ? true
                : false;

            let style = this.isAndroid
              ? this.button.button_style
              : this.button.button_style_ios;

            this.initialize(style, this.no_buttons);
          }
        }
      }
    );

    this.colorsComponentSubscription =
      this.mdw.colorsComponentContainer$.subscribe((data) => {
        if (
          data &&
          data.color_schema &&
          data.color_schema_ios &&
          data.light != null
        ) {
          this.colors = data;
          this.light = data.light;
          let style = this.isAndroid
            ? this.button.button_style
            : this.button.button_style_ios;
          this.initialize(style, this.no_buttons);
        }
      });
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        // only for getting default button to change style for active or none active button style

        if (data && data.button) {
          this.current_button = data.button;
          this.isActive =
            this.current_button &&
            this.current_button.button_id == this.button.button_id
              ? true
              : false;
          let style = this.isAndroid
            ? this.button.button_style
            : this.button.button_style_ios;
          this.initialize(style, this.no_buttons);
        }
      }
    );

    this.updateBuilderComponentSubscription =
      this.mdw.updateBuilderComponentContainer$.subscribe((data) => {
        if (data && data.tab) {
          // only to get different views for button for Android and iOS. if both same view we do not need this subscription.
          this.isAndroid =
            localStorage.getItem("mode")[0] == c1.ANDROID ? true : false;
          let style = this.isAndroid
            ? this.button.button_style
            : this.button.button_style_ios;
          this.initialize(style, this.no_buttons);
        }
      });
  }

  initialize(style, no_button) {
    this.isAndroid =
      localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;

    if (this.button) {
      this.imageUploaderSubOption = {
        ...this.imageUploaderSubOption,
        media_type: this.button.button_value_type.input,
        id: this.button.button_id,
      };
      this.currentImages = [];
      if(this.button && this.button.button_value && this.button.button_value.length > 0){

        for(let i = 0; i < this.button.button_value.length; i++) {
          if(typeof this.button.button_value[i].value === "string"){
            const value = this.button.button_value[i].value;
            this.currentImages.push(JSON.parse(value).url);
          }else{
            this.currentImages.push(this.button.button_value[i].value.url);
          }
        }
      }

      switch (this.button.button_value_type.input) {
        case "audio":
          this.imageUploaderSubOption.acceptedFiles = "audio/mid,audio/midi,audio/mp4,audio/mpeg,audio/ogg,audio/basic,audio/mp3";
          this.imageUploaderSubOption.title = this.button.button_label ? this.button.button_label : this.button.button_callback;
          this.imageUploaderSubOption.media_type = "audio";
          this.imageUploaderSubOption.keyword = "audio";
          this.imageUploaderSubOption.maxFileSize = 50;
          break;
        case "image":
          this.imageUploaderSubOption.acceptedFiles = "image/jpeg,image/pjpeg,image/png";
          this.imageUploaderSubOption.title = this.button.button_label ? this.button.button_label : this.button.button_callback;
          this.imageUploaderSubOption.media_type = "image";
          this.imageUploaderSubOption.keyword = "image";
          this.imageUploaderSubOption.maxFileSize = 20;
          break;
        case "video":
          this.imageUploaderSubOption.acceptedFiles = "video/mp4,video/webm,video/ogg,video/x-msvideo,video/x-matroska,video/quicktime,video/x-flv,video/3gpp,video/3gpp2,video/mpeg";
          this.imageUploaderSubOption.title = this.button.button_label ? this.button.button_label : this.button.button_callback;
          this.imageUploaderSubOption.media_type = "video";
          this.imageUploaderSubOption.keyword = "video";
          this.imageUploaderSubOption.maxFileSize = 50;
          break;
      }
    }
  }

  imagePreviewUpdate(value) {
    if (value && value.length > 0) {
      if (this.button.button_value_type.data === "object") {
        let val: ButtonOption = {
          id: this.button.button_id,
          value: {url: value[0].url},
        };
        this.button.button_value = [val];
      } else {
        let mediaList = [];
        for (let i = 0; i < value.length; i++) {
          let media = {};
          media["type"] = this.button.button_value_type.input;
          media["url"] = value[i].url;
          mediaList.push(media);
        }
        let val: ButtonOption = {
          id: this.button.button_id,
          value: mediaList
        };
        this.button.button_value = [val];
      }
    } else {
      this.button.button_value = null;
    }

    this.updateButtonData();
  }

  updateButtonData() {
    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true,
      true,
      false,
      this.ref
    );
  }

  ngOnDestroy(): void {
    if (this.updateBuilderComponentSubscription) {
      this.updateBuilderComponentSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }

    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }

    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
  }
}
